import React, { useState } from 'react';
import { Form, FormGroup, Label, Input, Alert } from 'reactstrap';

const PasswordForm = ({newPassword,setNewPassword,passwordError,setPasswordError,confirmPassword,setConfirmPassword}) => {
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  
  // Password validation
  const validatePassword = (password) => {
    if (password.length < 8) {
      return "Password must be at least 8 characters long";
    }
    
    if (!/[A-Z]/.test(password)) {
      return "Password must contain at least one uppercase letter";
    }
    
    if (!/[a-z]/.test(password)) {
      return "Password must contain at least one lowercase letter";
    }
    
    if (!/[0-9]/.test(password)) {
      return "Password must contain at least one number";
    }
    
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
      return "Password must contain at least one special character";
    }
    
    return null;
  };
  
  const handleNewPasswordChange = (e) => {
    const value = e.target.value;
    setNewPassword(value);
    
    // Validate password as user types
    const validationError = validatePassword(value);
    if (validationError) {
      setPasswordError(validationError);
    } else if (confirmPassword && value !== confirmPassword) {
      setPasswordError("Passwords do not match");
    } else {
      setPasswordError('');
    }
  };
  
  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);
    
    // Check if passwords match
    if (newPassword !== value) {
      setPasswordError("Passwords do not match");
    } else {
      setPasswordError('');
    }
  };
  
  // Toggle password visibility
  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };
  
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };
  
  return (
    <Form>
      <FormGroup>
        <Label for="newPassword">New Password</Label>
        <div className="position-relative">
          <Input
            type={showNewPassword ? "text" : "password"}
            name="newPassword"
            value={newPassword}
            onChange={handleNewPasswordChange}
            placeholder="Enter new password"
            className="pr-5"
          />
          <div 
            style={{ 
              position: 'absolute', 
              right: '10px', 
              top: '50%', 
              transform: 'translateY(-50%)',
              cursor: 'pointer'
            }}
            onClick={toggleNewPasswordVisibility}
          >
            {showNewPassword ? (
              <span style={{ fontSize: '16px' }}>&#128065;&#8205;</span> // Eye with slash (unicode)
            ) : (
              <span style={{ fontSize: '16px' }}>&#128065;</span> // Eye (unicode)
            )}
          </div>
        </div>
      </FormGroup>
      
      <FormGroup>
        <Label for="confirmPassword">Confirm Password</Label>
        <div className="position-relative">
          <Input
            type={showConfirmPassword ? "text" : "password"}
            name="confirmPassword"
            value={confirmPassword}
            onChange={handleConfirmPasswordChange}
            placeholder="Confirm new password"
            className="pr-5"
          />
          <div 
            style={{ 
              position: 'absolute', 
              right: '10px', 
              top: '50%', 
              transform: 'translateY(-50%)',
              cursor: 'pointer'
            }}
            onClick={toggleConfirmPasswordVisibility}
          >
            {showConfirmPassword ? (
              <span style={{ fontSize: '16px' }}>&#128065;&#8205;</span> // Eye with slash (unicode)
            ) : (
              <span style={{ fontSize: '16px' }}>&#128065;</span> // Eye (unicode)
            )}
          </div>
        </div>
      </FormGroup>
      
      {newPassword && (
        <div className="password-strength-indicator mb-3">
          <p className="mb-1">Password must contain:</p>
          <ul className="pl-3 mb-0">
            <li style={{ color: newPassword.length >= 8 ? 'green' : 'red' }}>
              At least 8 characters
            </li>
            <li style={{ color: /[A-Z]/.test(newPassword) ? 'green' : 'red' }}>
              At least one uppercase letter
            </li>
            <li style={{ color: /[a-z]/.test(newPassword) ? 'green' : 'red' }}>
              At least one lowercase letter
            </li>
            <li style={{ color: /[0-9]/.test(newPassword) ? 'green' : 'red' }}>
              At least one number
            </li>
            <li style={{ color: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(newPassword) ? 'green' : 'red' }}>
              At least one special character
            </li>
          </ul>
        </div>
      )}
      
      {passwordError && <Alert color="danger">{passwordError}</Alert>}
    </Form>
  );
};

export default PasswordForm;